import { Yup } from '../../../common/CommonExport';

export const validationSchema = Yup.object().shape({
    roleName: Yup.string().required('Role name is required'),
    description: Yup.string().required('Description is required'),
});
